import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';
import type { OpenEndedResponse } from '../types';
import { useOpenEndedPresentationContext } from '../../OpenEndedPresentationContext';
import { OpenEndedTitleDataHandler } from '../ui/OpenEndedTitleDataHandler';
import { SpeechBubbles } from './SpeechBubbles';
import { FlowingGrid } from './FlowingGrid';

interface VisualizationProps extends BoxT {
  CanvasVisualizationArea: InteractiveCanvasComponents['CanvasVisualizationArea'];
  shouldHideResults: boolean;
  shouldShowUpvotes: boolean;
  onOpenOneByOneView: (index: number) => void;
  responses: OpenEndedResponse[];
  numberOfColumns: number;
}

export const ResponsesView = ({
  shouldShowUpvotes,
  responses,
  shouldHideResults,
  onOpenOneByOneView,
  CanvasVisualizationArea,
  numberOfColumns,
  ...rest
}: VisualizationProps) => {
  const { shouldAnimate, visualization } = useOpenEndedPresentationContext();

  const shouldShowFlowingGrid =
    visualization === 'flowing_grid' && shouldAnimate;

  const ConditionalVisualizationWrapper = CanvasVisualizationArea ?? Box;

  return (
    <Box width="100%" height="100%">
      <OpenEndedTitleDataHandler showTextSizeDropdown={true} />
      <ConditionalVisualizationWrapper
        width="100%"
        flex="1 1 100%"
        p={1}
        extend={() => ({
          pointerEvents: 'auto',
        })}
      >
        <Box flex="1 1 auto" width="100%" height="100%" {...rest}>
          {shouldShowFlowingGrid ? (
            <FlowingGrid
              showUpvotes={shouldShowUpvotes}
              responses={responses}
              onItemClick={onOpenOneByOneView}
              numberOfColumns={numberOfColumns}
            />
          ) : (
            <SpeechBubbles
              showUpvotes={shouldShowUpvotes}
              responses={responses}
              onItemClick={onOpenOneByOneView}
              numberOfColumns={numberOfColumns}
            />
          )}
        </Box>
      </ConditionalVisualizationWrapper>
    </Box>
  );
};
